<template>
    <router-view />
</template>

<script>
export default {
    name: 'StatisticsBase',
};
</script>
